// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__1noEb","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__2beH2"};